export default __webpack_public_path__ + "static/media/animationscreen.2aa9c597.png";